import useGetManageLibrary from 'modules/media/services/hooks/useGetManageLibrary';
import React from 'react';
import { useMediaExplorer } from 'modules/media/services/hooks/useMediaExplorer';
import MediaManagerGalleryMode from '../Dashboard/LibraryList/GalleryMode';
import MediaManagerListMode from '../Dashboard/LibraryList/ListMode';
import MediaManagerGridMode from '../Dashboard/LibraryList/GridMode';
import styled from 'styled-components';
import useViewMode from 'modules/media/services/hooks/useViewMode';
import { useMediaQuery } from 'react-responsive';
import MediaMobile from '../Dashboard/MediaMobile';

const MediaFolderDetailPage = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [data, mutate] = useGetManageLibrary();
  const { mode: viewMode, setViewMode } = useViewMode();

  const { items, pathStack, openFolder, onBack, currentPath } = useMediaExplorer(data, mutate);

  if (isMobile) {
    return (
      <MediaMobile />
    );
  }
  
  return (
    <Container>
      <MediaManagerGalleryMode
        viewMode={viewMode}
        onChangeViewMode={setViewMode}
        path={pathStack}
        onBack={onBack}
        currentPath={currentPath}
        onSuccess={mutate}
      />
      {viewMode === 'list' ? (
        <MediaManagerListMode items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate} />
      ) : (
        <MediaManagerGridMode items={items} onOpenFolder={openFolder} currentPath={currentPath} onSuccess={mutate}/>
      )}
    </Container>
  );
};

export default MediaFolderDetailPage;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`;
